// extracted by mini-css-extract-plugin
module.exports = {"h1":"RelatedCourses_h1__cqvWI","h2":"RelatedCourses_h2__1Cqku","p":"RelatedCourses_p__1UaR0","container":"RelatedCourses_container__2jJ9h"};